// Central export for all mock data
// This file re-exports all mock data from individual modules for easy access

// Import all mock data objects for aggregation
import { mockAuthData } from './auth';
import { mockOverviewData } from './overview';
import { mockPromptsData } from './prompts';
import { mockDomainsData } from './domains';
import { mockUrlsData } from './urls';
import { mockGapAnalysisData } from './gapAnalysis';
import { mockInsightsData } from './insights';
import { mockEarnedData } from './earned';
import { mockOwnedData } from './owned';
import { mockImpactData } from './impact';
import { mockProfileData } from './profile';
import { mockBrandProfileDefault } from './brandProfile';
import { mockBrandsData } from './brands';

// Export independent modules first
export * from './auth';
export * from './common';
export * from './chat';
export * from './llmPlatforms';

// Export modules with simple dependencies
export * from './domains';
export * from './urls';
export * from './prompts';

// Export aggregate modules that depend on others
export * from './overview';
export * from './gapAnalysis';
export * from './insights';
export * from './earned';
export * from './owned';
export * from './impact';
export * from './profile';
export * from './brandProfile';
export * from './brands';
export * from './workspaces';

// Export all mock data as a single aggregated object for easy access
export const allMockData = {
  auth: mockAuthData,
  overview: mockOverviewData,
  prompts: mockPromptsData,
  domains: mockDomainsData,
  urls: mockUrlsData,
  gapAnalysis: mockGapAnalysisData,
  insights: mockInsightsData,
  earned: mockEarnedData,
  owned: mockOwnedData,
  impact: mockImpactData,
  profile: mockProfileData,
  brandProfile: mockBrandProfileDefault,
  brands: mockBrandsData
};
